import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { AzureAccesses } from "./accesses.ts";
import { AzureComponents } from "./components.ts";

const AzureFilters = {
  role: { keys: ["id", "name", "type"] },
  resource: { keys: ["id", "name", "type"] },
  subscription: { keys: ["id"] },
} as const satisfies AnyFilterSchema;

export type AzureFilters = typeof AzureFilters;

export const AzureRegistration = Registration({
  accesses: AzureAccesses,
  category: "resource",
  components: AzureComponents,
  docs: {
    install: "microsoft-azure",
    request: "microsoft-azure/requesting-access",
  },
  filters: AzureFilters,
  identifier: (key) => (key === "azure-app" ? "name" : "identifier"),
  itemKind: (key) => (key === "azure-app" ? "app" : "subscription"),
  label: "Microsoft Azure",
  logoUrl:
    "https://upload.wikimedia.org/wikipedia/commons/f/fa/Microsoft_Azure.svg",
  maturity: "ga",
  requestType: "requestable",
  // TODO: Should map iam_write, but was copied from existing code that omitted this mapping
  useMapping: [],
});

registerIntegration("azure", AzureRegistration);
